import { render, staticRenderFns } from "./DataCollection.vue?vue&type=template&id=1f3481bd&scoped=true&"
import script from "./DataCollection.vue?vue&type=script&lang=js&"
export * from "./DataCollection.vue?vue&type=script&lang=js&"
import style0 from "./DataCollection.vue?vue&type=style&index=0&id=1f3481bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3481bd",
  null
  
)

export default component.exports